import { useQuery } from '@tanstack/react-query';

import { AuthApi } from '../api';

export const CURRENT_ORG_QUERY_KEY = 'hcs-user-current-org';
export const useCurrentOrg = () => {
  return useQuery([CURRENT_ORG_QUERY_KEY], AuthApi.fetchCurrentOrg);
};
